import { render, staticRenderFns } from "./LanguageSetting.vue?vue&type=template&id=331f65b8&scoped=true&"
import script from "./LanguageSetting.vue?vue&type=script&lang=js&"
export * from "./LanguageSetting.vue?vue&type=script&lang=js&"
import style0 from "./LanguageSetting.vue?vue&type=style&index=0&id=331f65b8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "331f65b8",
  null
  
)

export default component.exports